import React from 'react';
import Iframe from 'react-iframe';

const SecondarySchoolPage = () => (
  <Iframe
    url='https://visualization.audit.samiksha.samagra.io/public/dashboard/461198a6-4042-4028-8097-281762da3a77'
    width='100%'
    height='100%'
    display='initial'
    position='relative'
  />
);

export default SecondarySchoolPage;
